import { Component } from '@theme/component';

class VibeMaterialsAnatomy extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('pointerenter', this.#onPointer, true);
    this.addEventListener('pointerleave', this.#onLeave, true);
    this.addEventListener('click', this.#onPointer);
  }

  #targets() {
    return this.querySelectorAll('[data-vibe-hotspot]');
  }

  #setActive(id) {
    for (const el of this.#targets()) {
      el.classList.toggle('is-active', id !== null && el.dataset.vibeHotspot === id);
    }
  }

  #onPointer = (event) => {
    const target = event.target.closest?.('[data-vibe-hotspot]');
    if (!target || !this.contains(target)) return;
    this.#setActive(target.dataset.vibeHotspot);
  };

  #onLeave = (event) => {
    const target = event.target.closest?.('[data-vibe-hotspot]');
    if (!target || !this.contains(target)) return;
    this.#setActive(null);
  };
}

if (!customElements.get('vibe-materials-anatomy')) {
  customElements.define('vibe-materials-anatomy', VibeMaterialsAnatomy);
}
